/**
 * Sunday store link: ?storename=<CODE> on a mattress or accessory page shows that store's four tiles
 * above Add to cart (snippets/sunday-store-tiles.liquid). The code is kept for the visit in
 * sessionStorage 'sunday-store', so it stays while the visitor browses. The store's pincode goes into the
 * page's pincode field; the date tile then shows the date and the long delivery line is hidden.
 * Unknown code or none: nothing shows.
 * Security: sends nothing anywhere. Reads only the URL parameter and the store records printed in the page.
 */
const KEY = 'sunday-store';

function code() {
  let c = '';
  try {
    c = new URLSearchParams(location.search).get('storename') || '';
  } catch (e) {
    c = '';
  }
  c = c.trim().toUpperCase();
  try {
    if (c) sessionStorage.setItem(KEY, c);
    else c = sessionStorage.getItem(KEY) || '';
  } catch (e) {
    /* storage blocked: the link still works on the page it opened */
  }
  return c;
}

class Tiles {
  constructor(el, st) {
    this.el = el;
    this.box = el.closest('#buy') || el.parentElement;
    this.when = el.querySelector('[data-st-when]');
    this.free = el.querySelector('[data-st-free]');
    this.freeWords = this.when.textContent;
    el.querySelector('[data-st-area]').textContent = st.area || st.city || '';
    const map = el.querySelector('[data-st-map]');
    if (st.map) map.href = st.map;
    else map.removeAttribute('href');
    const digits = String(st.phone || '').replace(/\D/g, '').replace(/^0/, '');
    const tel = el.querySelector('[data-st-tel]');
    if (digits) tel.href = `tel:+91${digits}`;
    else tel.removeAttribute('href');
    el.setAttribute('aria-label', (el.dataset.label || '').replace('[city]', st.city || ''));
    el.hidden = false;
    this.box.setAttribute('data-sd-store-on', '');
    const del = this.box.querySelector('sunday-delivery');
    if (del) {
      del.addEventListener('sunday:eta', (e) => this.paint(e.detail));
      if (del.eta !== undefined) this.paint(del.eta);
      this.fill(del, st.pin);
    }
  }

  /* The store's pincode into the page's field, checked like a typed one. */
  fill(del, pin) {
    if (!/^[1-9]\d{5}$/.test(pin || '')) return;
    const go = () => {
      const input = del.querySelector('input');
      if (!input || input.value === pin) return;
      input.value = pin;
      if (typeof del.check === 'function') del.check(pin, true);
    };
    customElements.whenDefined('sunday-delivery').then(() => requestAnimationFrame(go));
  }

  paint(eta) {
    if (!eta) {
      this.when.textContent = this.freeWords;
      this.free.hidden = true;
      return;
    }
    const d = this.el.dataset;
    this.when.textContent = `${d.arrives} `;
    if (eta.today) {
      this.when.append(d.today);
    } else {
      const [wd, rest] = eta.parts;
      if (wd) {
        const w = document.createElement('span');
        w.className = 'sd-stwd';
        w.textContent = `${wd} `;
        this.when.append(w);
      }
      this.when.append(rest);
    }
    this.free.hidden = false;
  }
}

const c = code();
if (c) {
  document.querySelectorAll('[data-sd-store]:not([data-on])').forEach((el) => {
    el.setAttribute('data-on', '');
    let list = [];
    try {
      list = JSON.parse(el.querySelector('script[type="application/json"]').textContent).filter(Boolean);
    } catch (e) {
      list = [];
    }
    const st = list.find((x) => String(x.code || '').toUpperCase() === c);
    if (st) new Tiles(el, st);
  });
}
